
import React from "react";
import "../IVRSolutions/IVRSolutions.css";
import {
    FaCheckCircle,
    FaPhone,
    FaWallet,
    FaBell,
    FaReply,
    FaHeartbeat,
    FaUniversity,
    FaBullhorn,
    FaShoppingCart,
    FaGraduationCap,
    FaBuilding,
} from "react-icons/fa";
import centerImage from "../../pages/IVRSolutions/assets/ss.png";
import flowMissedImage from "./assets/flow-missed.png";

const WhatsAppApi = () => {

return (
<>
    <div className="services-banner">
        <div className="overlay"></div>
        <div className="content">
            <div className="line"></div>
            <div>
                <h1>Missed Call </h1>
                <p>
                    A <b className="bold">missed call service</b> is a effective and value-powerful communique solution
                    that permits agencies <br />
                    to hook up with customers through a simple ignored call. </p>
                <p>
                    <span className="home">Home</span> → Service → Missed Call Service
                </p>
            </div>
        </div>
    </div>
    <section className="ivr-section">
        <div className="ivr-container">
            <section className="about-sectionvv">
                <div className="about-containervv">
                    <div className="about-contentvv">
                        <span className="about-tagvv">Missed Call</span>
                        <h1>What is Missed Call Service?</h1>
                        <p className="about-descvv">
                            A overlooked call service is a effective and fee-powerful communique solution that lets in
                            agencies to connect with clients thru a easy ignored call. Instead of requiring customers to
                            spend cash or time on long calls, customers can just deliver a neglected call, and the
                            machine mechanically captures their range and triggers a predefined reaction.
                        </p>
                        <div className="about-featuresvv">
                            <div className="feature-rightvv">
                                <p>
                                    <FaCheckCircle /> Capture customer leads instantly through a simple missed call
                                </p>
                                <p>
                                    <FaCheckCircle /> Send automatic responses using missed call alert system
                                </p>
                                <p>
                                    <FaCheckCircle /> Provide a cost-free and easy communication method for users
                                </p>
                                <p>
                                    <FaCheckCircle /> Track and manage customer data efficiently with missed call
                                    service
                                </p>
                            </div>
                        </div>
                        <br />
                    </div>
                </div>
                <section className="services-bb">
                    <div className="container-bb">
                        <h5 className="subheading-bb"> Missed Call Service Flow</h5>
                        <h2 className="heading-bb">
                            Missed Call Service Flow
                        </h2>

                        <div style={{ marginTop: "24px" }}>
                            <img
                                src={flowMissedImage}
                                alt="Missed call service flow diagram"
                                style={{ width: "100%", maxWidth: "1100px", height: "auto", display: "block", margin: "0 auto" }}
                            />
                        </div>
                    </div>
                </section>
                <section className="why-section">
                    <div className="why-left">
                        <span className="tags">Needs</span>
                        <h1>Why Your Business Needs Missed Call Service</h1>

                        <p>
                            Modern clients choose short and easy ways to interact with businesses. A missed call
                            provider provides a easy, consumer-pleasant approach for clients to connect without any fee.
                            Here’s why your business desires a <b className="bold">missed call alert</b> machine:
                        </p>
                    </div>
                    <br />
                    <div className="why-container">
                        <div className="why-right">
                            <div className="card">
                                <p>
                                    <FaPhone className="why-icon" /> Easy communication through a simple <b className="bold">missed call</b>
                                </p>
                            </div>

                            <div className="card">
                                <p>
                                    <FaWallet className="why-icon" /> Cost-effective solution for both commercial enterprise and clients
                                </p>
                            </div>

                            <div className="card">
                                <p>
                                    <FaBell className="why-icon" /> Instant notification through overlooked name alert </p>
                            </div>

                            <div className="card">
                                <p>
                                    <FaReply className="why-icon" /> Quick observe-up possibilities </p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="why-sectionz">
                    <h2>Key Features of Missed Call Service</h2>
                            <div className="why-containerz">
                        <div className="why-gridz">
                            <div className="why-colz">
                                <p>
                                    <FaCheckCircle />
                                    Instant Call Capture
                                </p>
                                <p>
                                    <FaCheckCircle /> Real-Time Missed Call Alert
                                </p>
                                <p>
                                    <FaCheckCircle /> Automated Response System
                                </p>
                            </div>
                            <div className="why-colz">
                                <p>
                                    <FaCheckCircle />Lead Generation Tool
                                </p>
                                <p>
                                    <FaCheckCircle /> Integration with CRM
                                </p>
                                <p>
                                    <FaCheckCircle /> Telecom Support
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="industriesss">
                    <h2>Industries We Serve</h2>
                    <br />
                    <div className="industries-containerss">
                        <div className="industries-rightss">
                            <div className="cardss"><FaHeartbeat className="industry-icon" /> Healthcare</div>
                            <div className="cardss"><FaUniversity className="industry-icon" /> Finance & Banking</div>
                            <div className="cardss"><FaBullhorn className="industry-icon" /> Media & Marketing</div>
                            <div className="cardss"><FaShoppingCart className="industry-icon" /> E-commerce</div>
                            <div className="cardss"><FaGraduationCap className="industry-icon" /> Education</div>
                            <div className="cardss"><FaBuilding className="industry-icon" /> Real Estate</div>
                        </div>
                    </div>
                </section>
                <section className="whyss">
                    <p className="subtitless">WHY CHOOSE US</p>
                    <h2 className="titless">
                        Why Choose Us for Missed Call Service
                    </h2>
                    <p>
                        Choosing the right company for your overlooked call carrier is vital for maximizing
                        consequences. Here’s why businesses believe us:

                    </p>

                    <div className="why-containerss">
                        <div className="center-imagess">
                            <img src={centerImage} alt="transport" />
                        </div>

                        <div className="left-cardsss">
                            <div className="cardsss left-card card1">
                                <span>Advanced Technology</span>
                            </div>
                            <div className="cardsss left-card card2">
                                <span>Instant Notifications</span>
                            </div>
                        </div>

                        <div className="right-cards">
                            <div className="cardsss left-card card3">
                                <span>High Performance & Accuracy</span>
                            </div>
                            <div className="cardsss right-card card4">
                                <span>Custom Campaign Solutions</span>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </div>
    </section>
</>
);
};

export default WhatsAppApi;
